// Mock data for Faro Sports website

export const heroSlides = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_e3f33928-ddb3-491f-842a-58add10dbfc1/artifacts/51t9zh25_Slide1.jpg",
    title: "Acompañamos talentos",
    subtitle: "para concretar sueños"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_e3f33928-ddb3-491f-842a-58add10dbfc1/artifacts/bwp9fkqq_Slide2.jpg",
    title: "Potenciamos carreras",
    subtitle: "hacia el éxito mundial"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_e3f33928-ddb3-491f-842a-58add10dbfc1/artifacts/5m2hivy1_Slide3.jpg",
    title: "Tu futuro",
    subtitle: "comienza aquí"
  }
];

export const aboutData = {
  title: "Quienes Somos",
  paragraphs: [
    "FARO Sports es una agencia de representación creada para potenciar y promover el talento de jugadores de fútbol y promover su carrera profesional en los principales clubes de fútbol de Uruguay y del mundo.",
    "FARO Sports nace en la conjunción de proyectos e ideas en común de Sebastián Taborda y Gonzalo Sorondo, dos exitosos y destacados jugadores del Fútbol Uruguayo e Internacional, que han decidido aunar esfuerzos profesionales para promover talentos en el mundo del fútbol.",
    "En FARO Sports la carrera profesional de los jugadores representados no tiene techo, aspirando a que logren concretar todos sus sueños y desafíos en un mundo del fútbol cada más competitivo y exigente, en base al profesionalismo y los esfuerzos en común."
  ]
};

export const services = [
  {
    id: 1,
    title: "Representación de Futbolistas",
    description: "Gestión integral de la carrera profesional de jugadores de fútbol a nivel nacional e internacional.",
    icon: "users"
  },
  {
    id: 2,
    title: "Captación de Talentos",
    description: "Identificación y desarrollo de jóvenes promesas con proyección profesional.",
    icon: "search"
  },
  {
    id: 3,
    title: "Seguimiento Profesional",
    description: "Acompañamiento continuo en cada etapa del desarrollo deportivo del jugador.",
    icon: "compass"
  },
  {
    id: 4,
    title: "Relación con Clubes",
    description: "Conexiones estratégicas con clubes de primer nivel en Uruguay y el mundo.",
    icon: "building"
  },
  {
    id: 5,
    title: "Asesoramiento Integral",
    description: "Orientación legal, financiera y personal para el bienestar del jugador.",
    icon: "shield"
  },
  {
    id: 6,
    title: "Marketing Deportivo",
    description: "Gestión de imagen, sponsors y presencia en medios del jugador.",
    icon: "megaphone"
  }
];

export const staff = [
  {
    id: 1,
    name: "Gonzalo Sorondo",
    role: "Socio Director",
    image: process.env.PUBLIC_URL + "/images/staff/gonzalo_sorondo.jpg",
    bio: "Ex futbolista en Inter de Milán (Italia), Standard Lieja (Bélgica), Crystal Palace y Charlton (Inglaterra), Sport Club Internacional (Brasil). Campeón Copa Sudamericana 2008 y Copa Libertadores 2010. Internacional uruguayo, disputó el Mundial Japón-Corea 2002.",
    linkedin: "https://www.linkedin.com/in/gonzalo-sorondo-81965779/",
    twitter: "https://twitter.com/gsorondo4",
    instagram: "https://www.instagram.com/g_sorondo/"
  },
  {
    id: 2,
    name: "Sebastián Taborda",
    role: "Socio Director",
    image: process.env.PUBLIC_URL + "/images/staff/sebastian_taborda.jpg",
    bio: "Ex futbolista en Defensor Sporting (Uruguay), UNAM Pumas (México), Real Deportivo La Coruña (España), Newell's Old Boys (Argentina), Nacional (Uruguay). Campeón uruguayo 2014-2015 con Nacional. Internacional uruguayo.",
    linkedin: "#",
    twitter: "#",
    instagram: "#"
  },
  {
    id: 3,
    name: "Fabián Coelho",
    role: "Scouting Fútbol Profesional y Juvenil",
    image: process.env.PUBLIC_URL + "/images/staff/fabian_coelho.png",
    bio: "Ex futbolista en Nacional, Elche (España) y varios clubes uruguayos. 6 veces campeón uruguayo. Internacional uruguayo 1997-2001. Subcampeón Mundial Sub-20 Malasia 1997.",
    linkedin: "#",
    twitter: "https://twitter.com/FabiFaroSports",
    instagram: "https://www.instagram.com/coelhofarosports/"
  },
  {
    id: 4,
    name: "Sebastián Viera",
    role: "Scouting Fútbol Profesional y Juvenil",
    image: process.env.PUBLIC_URL + "/images/staff/sebastian_viera.png",
    bio: "Ex futbolista formado en Defensor Sporting. Jugó en ligas de Perú, Guatemala, Bolivia, Israel y Uruguay. Integró selecciones juveniles Sub-15, Sub-17 y Sub-20 de Uruguay.",
    linkedin: "#",
    twitter: "https://twitter.com/vierafarosport1",
    instagram: "https://www.instagram.com/sebavierafaro/"
  },
  {
    id: 5,
    name: "Gabriel Pereira",
    role: "Scouting Fútbol Profesional y Juvenil",
    image: process.env.PUBLIC_URL + "/images/staff/gabriel_pereira.png",
    bio: "Ex futbolista formado en River Plate (Uruguay). Jugó en Argentina (Chacarita Juniors) y Uruguay. Integró selección Sub-15 de Uruguay. Entrenador Licencia A.",
    linkedin: "#",
    twitter: "https://twitter.com/gabypereirafaro",
    instagram: "https://www.instagram.com/gabypereirafaro/"
  }
];

export const players = [
  {
    id: 1,
    name: "Nicolás De La Cruz",
    position: "Mediocampista",
    club: "Flamengo",
    country: "Uruguay",
    image: process.env.PUBLIC_URL + "/images/players/De-la-Cruz-Flamengo2.webp",
    image2: process.env.PUBLIC_URL + "/images/players/De-la-Cruz-Flamengo3.webp"
  },
  {
    id: 2,
    name: "Brian Ocampo",
    position: "Extremo",
    club: "Cádiz CF",
    country: "Uruguay",
    image: process.env.PUBLIC_URL + "/images/players/brian_ocampo_cadiz.webp",
    image2: process.env.PUBLIC_URL + "/images/players/brian_ocampo_cadiz_2.webp"
  },
  {
    id: 3,
    name: "Agustín Canobbio",
    position: "Extremo",
    club: "Athletico Paranaense",
    country: "Uruguay",
    image: process.env.PUBLIC_URL + "/images/players/Agustin-Canobbio-web_2.webp",
    image2: process.env.PUBLIC_URL + "/images/players/CANOBBIO01.webp"
  },
  {
    id: 4,
    name: "Matías Arezo",
    position: "Delantero",
    club: "Internacional",
    country: "Uruguay",
    image: process.env.PUBLIC_URL + "/images/players/matias_arezo.webp",
    image2: process.env.PUBLIC_URL + "/images/players/matias_arezo.webp"
  }
];

export const stats = [
  { id: 1, value: "50+", label: "Jugadores Representados" },
  { id: 2, value: "15+", label: "Países con Presencia" },
  { id: 3, value: "100+", label: "Transferencias Exitosas" },
  { id: 4, value: "7", label: "Años de Experiencia" }
];

export const contactInfo = {
  email: "info@farosports.com.uy",
  phone: "+598 99 123 456",
  address: "Montevideo, Uruguay",
  social: {
    instagram: "https://instagram.com/farosports",
    twitter: "https://twitter.com/farosports",
    linkedin: "https://linkedin.com/company/farosports"
  }
};
